import { useQuery } from '@tanstack/react-query'

import { socketTokenQueryOptions } from './useWebsocketToken'
import { Entity } from '../hooks'

export const useActivityFeedWebsocketToken = (
  entities: Entity[]
): {
  shipmentWebsocketToken: string | undefined
  bookingWebsocketToken: string | undefined
} => {
  const shipmentEntity = entities.find((entity) => entity.type === 'shipment')
  const bookingEntity = entities.find((entity) => entity.type === 'booking')
  const bookingTokenQuery = useQuery(
    socketTokenQueryOptions(
      {
        referenceId: bookingEntity?.id || '',
        type: bookingEntity?.type || 'booking',
      },
      !!bookingEntity
    )
  )
  const shipmentTokenQuery = useQuery(
    socketTokenQueryOptions(
      {
        referenceId: shipmentEntity?.id || '',
        type: shipmentEntity?.type || 'shipment',
      },
      !!shipmentEntity
    )
  )

  return {
    shipmentWebsocketToken: shipmentTokenQuery?.data?.token,
    bookingWebsocketToken: bookingTokenQuery?.data?.token,
  }
}
